import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import type { FilterOption } from '@bizzdesign/data-access-search';
import type { SearchScope } from '@bizzdesign/sdk-search';
import { SharedI18nModule } from '@bizzdesign/shared/i18n';
import { TranslateDisplayTextPipe } from '@bizzdesign/shared/pipes';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'bd-quick-filters',
  imports: [
    AsyncPipe,
    ButtonModule,
    SharedI18nModule,
    TranslateDisplayTextPipe,
  ],
  templateUrl: './quick-filters.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuickFiltersComponent {
  @Input() filters: FilterOption<SearchScope>[] = [];
  @Input() searchResultsCountsPerScope: Map<string, number> = new Map<
    SearchScope,
    number
  >();
  @Input() searchResultsCountsPerScopeLoading: boolean = false;

  @Output() updateFilters: EventEmitter<SearchScope> = new EventEmitter();
  @Output() advancedFilterVisible: EventEmitter<boolean> = new EventEmitter();

  applyFilter(selectedFilterOption: FilterOption<SearchScope>) {
    this.updateFilters.emit(selectedFilterOption.key);
  }

  showAdvancedFilter() {
    this.advancedFilterVisible.emit(true);
  }
}
